import { useState } from 'react';

import { Link as RouterLink } from 'react-router-dom';
import uniqId from 'uniqid';
import Icons from 'assets/icons';


import { Box } from 'ui/box';

import ResponsiveWrapper from 'components/shared/others/responsive-wrapper/responsive-wrapper';
import classNames from 'classnames';

interface LinkItem {
  name?: string;
  route: string;
}

interface LinkProps {
  name?: string;
  route: string;
}

const Link = ({ name, route }: LinkProps): React.JSX.Element => {
  const [isHovered, setIsHovered] = useState<boolean>(false);

  return (
    <RouterLink
      to={route}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="py-5 px-3 border-b border-navy-200 font-semibold hover:bg-navy-50 transition duration-200 flex justify-between items-center">
        <Box sx={{ color: 'tokens.gray.950' }}>{name}</Box>

        <Icons.Arrow
          className={classNames('shrink-0 text-blue-700', {
            'text-navy-800': isHovered,
          })}
        />
      </div>
    </RouterLink>
  );
};

interface LinksProps {
  items?: LinkItem[];
}

const Links = ({ items = [] }: LinksProps): React.JSX.Element => (
  <ResponsiveWrapper>
    {items.map(({ name, route }) => (
      <Link key={uniqId()} name={name} route={route} />
    ))}
  </ResponsiveWrapper>
);

export default Links;
